import gsap from 'gsap';

import Component from '../base/component';
import { byId, qsa } from '../base/dom-utils';

class Shapes extends Component {

    constructor(el, opts) {
        super(el, opts);

        // based on scrollbar, if we don't have, quit
        if (this.options.scrollbarInstance === null || this.options.scrollbarInstance === undefined) {

            return false;
        }

        this.handleScroll = this.handleScroll.bind(this);

        this.$els.bigSquare = byId(this.options.bigSquare);
        this.$els.bigCircle = byId(this.options.bigCircle);

        this.$els.smallSquare = byId(this.options.smallSquare);
        this.$els.smallCircle = byId(this.options.smallCircle);

        this.$els.shapes = qsa('img', this.$el);

        this._currentRotation = 0;
        this._rotationSpeed = 0.45;
    }

    beforeInit() {
        this.options.scrollbarInstance.addListener(this.handleScroll);

        this.rotateElements();
    }

    rotateElements() {

        const move = () => {

            this._currentRotation += this._rotationSpeed;

            gsap.to(this.$els.smallCircle, 0.65, {
                rotation: this._currentRotation
            });

            gsap.to(this.$els.smallSquare, 0.65, {
                rotation: this._currentRotation
            });

            window.requestAnimationFrame(move);

        };

        move();

    }

    handleScroll() {

        const _scrollbar = this.options.scrollbarInstance;

        // we allow to move circle only 10% of page on height
        const bigCircleAllowedMove = window.innerHeight * 10 / 100;

        // we allow to move circle only 15% of page on height
        const bigSquareAllowedMove = window.innerHeight * 8 / 100;

        // get current document height
        const documentHeight = _scrollbar.getSize().content.height - _scrollbar.getSize().container.height;

        // get scroll percentage
        const scrollPercentage = _scrollbar.scrollTop * 100 / documentHeight;

        // move the right percentage based on max allowed move
        const bigCircleMovement = bigCircleAllowedMove * scrollPercentage / 100;
        const bigSquareMovement = bigSquareAllowedMove * scrollPercentage / 100;


        gsap.to(this.$els.bigCircle, 1, {
            y: -bigCircleMovement,
            opacity: 1
        });

        gsap.to(this.$els.bigSquare, 1, {
            y: bigSquareMovement,
            opacity: 1
        });


        gsap.to(this.$els.smallCircle, 1, {
            y: -bigCircleMovement / 2,
            opacity: 1
        });

        gsap.to(this.$els.smallSquare, 1, {
            y: -bigSquareMovement / 2,
            opacity: 1
        });
    }

    getDefaultOptions() {
        return {
            bigSquare: 'big-square',
            bigCircle: 'big-circle',
            smallSquare: 'small-square',
            smallCircle: 'small-circle',
            scrollbarInstance: null
        };
    }
}

export default Shapes;


/** WEBPACK FOOTER **
 ** ./components/shapes.js
 **/